import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/DbosPricingPage.head';
import { DbosPricingPage } from '@pages/DbosPricingPage';

export const Route = createFileRoute('/dbos-pricing')({
  component: DbosPricingPage,
  head: () => head,
});
